import { useEffect, useState } from 'react';
import ReferralMetricService, {
  CommunitySummary,
  MyReferralMetrics,
} from '../../application/services/ReferralMetricService';

interface CommunityMetricsState {
  isLoading: boolean;
  error: string | null;
  myReferrals: MyReferralMetrics | null;
  community: CommunitySummary | null;
}

/**
 * Data-fetching for /my-community, kept out of the page component per this
 * app's layer discipline (pages stay thin). Currently backed by
 * ReferralMetricService's stub — see the TODOs there for the real swap-in.
 */
export function useCommunityMetrics(): CommunityMetricsState {
  const [state, setState] = useState<CommunityMetricsState>({
    isLoading: true,
    error: null,
    myReferrals: null,
    community: null,
  });

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const [myReferrals, community] = await Promise.all([
          ReferralMetricService.getMyReferrals(),
          ReferralMetricService.getCommunitySummary(),
        ]);
        if (!cancelled) {
          setState({ isLoading: false, error: null, myReferrals, community });
        }
      } catch (err) {
        if (!cancelled) {
          setState({
            isLoading: false,
            error: err instanceof Error ? err.message : 'Failed to load community data',
            myReferrals: null,
            community: null,
          });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
